import { render } from "./RAGCarrierFocusedDemo.vue?vue&type=template&id=3205be7d&scoped=true"
import script from "./RAGCarrierFocusedDemo.vue?vue&type=script&lang=js"
export * from "./RAGCarrierFocusedDemo.vue?vue&type=script&lang=js"

import "./RAGCarrierFocusedDemo.vue?vue&type=style&index=0&id=3205be7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3205be7d"]])

export default __exports__